import React, { useContext } from "react";
import './Page.scss'
import CartoucheInfos from 'components/CartoucheInfos';
import { SettingsContext } from 'Providers/SettingsProvider';
import Grid from '@material-ui/core/Grid';
import Utils from 'utils/Utils';
import Mod from 'components/Mod';
import Image from 'components/Image';
import Share from 'components/Share';
import SwiperCore, { Navigation, Autoplay, A11y } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';
SwiperCore.use([Navigation, Autoplay, A11y]);

function PageInner({page,type=true,refresh=()=>null}) {
  const { translate } = useContext(SettingsContext);
  const dataPage=page ? [
    {...(type ? {key_tr:page.rubrique ? translate(page.rubrique,'title') : translate(page,'title')} : {}),value:translate(page,'title')},
  ]: [];
  return page ? <div className='page'>
  <Grid container spacing={2}>
    <Grid item xs={12} md={8}>
      <CartoucheInfos data={dataPage}/>
      {page.visuel && <div className="page-visuel">
          <Image credits file={page.visuel} thumbnailKey={"16-9"} ratio={0.5625} nocrop={true} align='left'/>
      </div>}
      { page.diaporama && page.diaporama.length>0 && <div className="page-diaporama">
        {
        page.diaporama && page.diaporama.length>0 ?
          <Swiper
          speed={800}
          loop
          autoplay={{
            delay: 3000,
          }}
          enabled={page.diaporama.length>1}
          navigation={page.diaporama.length>1}
          >
            {page.diaporama.map((diap,i)=>{
              const img=diap.directus_files_id;
              return <SwiperSlide key={img.id}>
                <Image credits file={img} thumbnailKey={"16-9"} ratio={0.5625}/>
              </SwiperSlide>;
            })}
          </Swiper>
          : ''
        }
      </div>}
      <div className="page-text select">
        {Utils.parseWithLinks(translate(page,'text'))}
      </div>
      <Share/>
    </Grid>
  </Grid>
  <Mod url={page.__typename+'/'+page.id} refresh={refresh}/>
  </div> : '';
}
export default PageInner;
